(() => {
  const enhance = (form) => {
    if (form.dataset.localizationEnhanced === 'true') return;
    form.dataset.localizationEnhanced = 'true';
    form.classList.add('localization-form--enhanced');

    form.querySelectorAll('[data-localization-select]').forEach((select) => {
      select.addEventListener('change', () => form.requestSubmit());
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-localization-form]').forEach(enhance);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
